// @flow
/** @jsx jsx */

import { Colors } from '@zapier/design-system';
import { jsx } from '@emotion/core';

const style = {
  color: Colors.red500,
  fontSize: '11px',
};

const Required = () => <span css={style}>(required)</span>;

export default Required;
